<script>
	import {onMount} from "svelte";
    export let colors =   ['#fe4a49', '#2ab7ca', '#fed766', '#e6e6ea', '#f4f4f8']
    export let inSVG = true;
        
    let dataURL
        
    let dpr = window.devicePixelRatio;
	let createCircleAttempts =100;
	
	let minRadius =3;
	let maxRadius = 600;
	

	
	let canvas = document.createElement("CANVAS")
    let context 
    let size = 1200;
    export let w = 1200;
    export let h = 1800;
	
	let circles = [];
	let totalCircles=500;
	
	onMount(()=>{
        context = canvas.getContext('2d');        
        context.scale(dpr, dpr);		
				var dpr = window.devicePixelRatio;
				canvas.width = w * dpr;
				canvas.height = h * dpr;
				context.scale(dpr, dpr);	
                context.lineWidth = 8;			
					
				for( var i = 0; i < totalCircles; i++ ) {  
  				createAndDrawCircle();
				}
		
		 dataURL = canvas.toDataURL();
	});
	
	   function randomNumber() {
		return (Math.random()+.2);
	}
	

function createAndDrawCircle() {  
  var newCircle;
  var circleSafeToDraw = false;
  for(var tries = 0; tries < createCircleAttempts; tries++) {
    newCircle = {
      x: Math.floor(Math.random() * w),
      y: Math.floor(Math.random() * h),
      radius: minRadius
    }
    
    if(doesCircleHaveACollision(newCircle)) {
      continue;
    } else {
      circleSafeToDraw = true;
      break;
    }
  }
	

  if(!circleSafeToDraw) {
    return;
  }

  for(var radiusSize = minRadius; radiusSize < maxRadius; radiusSize++) {
    newCircle.radius = radiusSize;
    if(doesCircleHaveACollision(newCircle)){
      newCircle.radius;
      break;
    } 
  }

  circles.push(newCircle);
  
  //var colors = ['4a4e4d','0e9aa7','3da4ab','f6cd61','fe8a71']
  
	 for (var i = 0; i < 5; i++){

        var randomNum = Math.floor(Math.random()*colors.length)

        context.fillStyle = colors[randomNum];	  
		// context.fillStyle="rgba(0,0,0,"+1/(i)+")"
	    context.beginPath();
  	    context.arc(newCircle.x, newCircle.y, newCircle.radius/(i), 0, 2*Math.PI);
  	    context.fill()
        context.lineWidth = 8;
        context.strokeStyle = "rgba(0,0,0,.5)";
            
	    }
}
  

function doesCircleHaveACollision(circle) {
	
  for(var i = 0; i < circles.length; i++) {
    var otherCircle = circles[i];
    var a = circle.radius + otherCircle.radius;
    var x = circle.x - otherCircle.x;
    var y = circle.y - otherCircle.y;

    if (a >= Math.sqrt((x*x) + (y*y))) {
      return true;
    }
  }
  
  if(circle.x + circle.radius >= size ||
     circle.x - circle.radius <= 0) {
    return true;
  }
    

  
  return false;
}
	


</script>

{#if inSVG}
    <g>
        <rect width="100%" height="100%" fill="white" />
        <image xlink:href={dataURL} width="100%" height="100%" />
    </g>
{:else}
    <img src={dataURL} width={w} height={h} />
{/if}
